import { Box, Typography } from '@mui/material';

type AppFooterProps = {
  mode?: 'light' | 'dark';
};

export default function AppFooter({ mode = 'light' }: AppFooterProps) {
  const color = mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'text.secondary';
  const borderColor = mode === 'dark' ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.08)';

  return (
    <Box
      component="footer"
      sx={{
        py: 2.5,
        px: 2,
        textAlign: 'center',
        borderTop: `1px solid ${borderColor}`,
      }}
    >
      <Typography variant="caption" sx={{ color }}>
        @2025 Sétima. Todos os direitos reservados. Todo o conteúdo deste site é protegido por leis de propriedade intelectual.
      </Typography>
    </Box>
  );
}
